module.exports = __webpack_public_path__ + "static/assets/c29721cdb70409c7ad3d5e112619330d.svg";